import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import RichText from '../../../../../utils/RichText';
import { friendlyURICharacters, replaceSpaces } from '../../../../../utils/functions';

const Landing = ({
  questForm,
  onRichTextUpdate,
  slugRef,
  rteDefaultConfig
}) => {
  return (
    <div>
      <div ref={slugRef} />
      <Field
        type="text"
        name="slug"
        id="slug"
        placeholder="Slug"
        customLabel="Slug"
        component={CustomInput}
        normalize={slug => friendlyURICharacters(replaceSpaces(slug))}
      />
      
      {questForm.values && (
        <label className="Label__URL">
          URL: {window.location.origin}/quests/{questForm.values.slug}
        </label>
      )}
      
      <div className="input-container main_desc">
        <label>Description</label>
        {questForm?.values && (
          <RichText
            initialValue={questForm.values.description}
            callback={content => onRichTextUpdate(content, 'description')}
            config={rteDefaultConfig}
          />
        )}
      </div>
    </div>
  );
};

Landing.propTypes = {
  questForm: PropTypes.shape({
    values: PropTypes.shape({
      slug: PropTypes.string,
      description: PropTypes.string
    })
  }).isRequired,
  onRichTextUpdate: PropTypes.func.isRequired,
  slugRef: PropTypes.func.isRequired,
  rteDefaultConfig: PropTypes.object
};

export default Landing;